import TemplateView from '../TemplateView'
import SimpleTooltip from '../SimpleTooltip'
import $ from 'jquery'
import {isEnter} from '../keyHandlers'

export default class Button extends TemplateView {
    constructor({
        additionalClass = '',
        onClickCb = () => {},
        label = '',
        withPlusIcon = false,
        withDisableTooltip = false,
        tooltipAdditionalClass = false,
        tabindex = -1,
        handleEnterKeydown = false,
    }) {
        super(null)

        this.params = {
            additionalClass,
            onClickCb,
            withPlusIcon,
            withDisableTooltip,
            tooltipAdditionalClass,
            tabindex,
            handleEnterKeydown,
        }

        this.state = {
            label,
            disabled: false,
            disableTooltipText: '',
        }

        this.onAnyStatePropertyChanged(['disabled', 'disableTooltipText'], ({disabled, disableTooltipText}) => {
            this.$el.toggleClass('disabled', disabled)
            if (this.params.withDisableTooltip) {
                this.tooltip.setText(disableTooltipText)
                this.tooltip.toggle(disabled)
            }
        })
        this.onStatePropertyChanged('label', label => {
            this.getEl().text(label);
        })
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            label: this.state.label,
            tabindex: this.params.tabindex
        }
    }

    templateHtml() {
        return '<div class="components_button <%=additionalClass%>" tabindex=<%=tabindex%>>' +
               '  <%-label%>' +
               '</div>'
    }

    afterRender() {
        this.$el.on('click', this._handleClick)
        this._updateClasses()

        if (this.params.withDisableTooltip) {
            this.tooltip = new SimpleTooltip({
                extraClass: this.params.tooltipAdditionalClass,
            }).init($('body'))
            this.tooltip.subscribeToMouseEvents(this.$el)
            this.tooltip.disable()
        }

        if (this.params.handleEnterKeydown) {
            this.$el.keydown(e => {
                if (isEnter(e.keyCode)) {
                    this.params.onClickCb()
                }
            })
        }
    }

    focus() {
        this.$el.focus()
    }

    _handleClick = (e) => {
        e.stopPropagation()
        if (!this.state.disabled) {
            this.params.onClickCb(e)
        }
    }

    _updateClasses() {
        this.$el
            .toggleClass('withPlusIcon', this.params.withPlusIcon)
            .toggleClass('disabled', this.state.disabled)
    }
}



// WEBPACK FOOTER //
// ./web/js/components/Button.js